import identityManager from '@arcgis/core/identity/IdentityManager';
import Portal from '@arcgis/core/portal/Portal';
import PortalQueryParams from '@arcgis/core/portal/PortalQueryParams';
import esriConfig from '@arcgis/core/config';
import Layer from '@arcgis/core/layers/Layer';
import OAuthInfo from '@arcgis/core/identity/OAuthInfo';
import Editor from '@arcgis/core/widgets/Editor';
import MapView from '@arcgis/core/views/MapView';
import Map from '@arcgis/core/Map';
import { DeckLayer } from '@deck.gl/arcgis'; // Not _really_ an ArcGIS object, but very integral to our use of ArcGIS
import Locate from '@arcgis/core/widgets/Locate';
import ScaleBar from '@arcgis/core/widgets/ScaleBar';
import { SpatialReference } from '@arcgis/core/geometry';

const arcGisFactory = () => (
  {
    identityManager,
    setEsriApiKey: (key) => { esriConfig.apiKey = key; },
    setEsriPortalUrl: (url) => { esriConfig.portalUrl = url; },
    newPortal: () => (new Portal()),
    newPortalQueryParams: (args) => (new PortalQueryParams(args)),
    fromPortalItem: (args) => (Layer.fromPortalItem(args)),
    newOAuthInfo: (args) => (new OAuthInfo(args)),
    newEditorWidget: (args) => (new Editor(args)),
    newMapView: (args) => (new MapView(args)),
    newMap: (args) => (new Map(args)),
    newDeckGLLayer: (args) => (new DeckLayer(args)),
    newLocateWidget: (args) => (new Locate(args)),
    newScaleBarWidget: (args) => (new ScaleBar(args)),
    newSpatialReference: (args) => (new SpatialReference(args)),
  }
);

export default arcGisFactory;
